import { render, staticRenderFns } from "./mini.vue?vue&type=template&id=2f3920d4&scoped=true"
import script from "./mini.vue?vue&type=script&lang=js"
export * from "./mini.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3920d4",
  null
  
)

export default component.exports